function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.001 15C15.6578 15 17.001 13.6569 17.001 12C17.001 10.3431 15.6578 9 14.001 9C12.3441 9 11.001 10.3431 11.001 12C11.001 13.6569 12.3441 15 14.001 15Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 0C7.4 0 2 5.4 2 12C2 18.6 7.4 24 14 24C20.6 24 26 18.6 26 12C26 5.4 20.6 0 14 0ZM14 1.5C14.75 1.5 15.5 2.25 15.5 3C15.5 3.75 14.75 4.5 14 4.5C13.1 4.5 12.5 3.9 12.5 3C12.5 2.1 13.1 1.5 14 1.5ZM14 18C10.7 18 8 15.3 8 12C8 8.7 10.7 6 14 6C17.3 6 20 8.7 20 12C20 15.3 17.3 18 14 18Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2998 30.0004H1.69984C0.499843 30.0004 -0.250157 28.6504 0.349843 27.7504L3.34984 22.6504C6.04984 25.3504 9.79984 27.0004 13.8498 27.0004C17.8998 27.0004 21.6498 25.3504 24.3498 22.6504L27.3498 27.7504C28.2498 28.6504 27.4998 30.0004 26.2998 30.0004Z",
  fill: "current"
});

function SvgWebcams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcams);
export default __webpack_public_path__ + "static/media/webcams.485c7686.svg";
export { ForwardRef as ReactComponent };